export default __webpack_public_path__ + "static/media/footer-youtube.b3d7b37d.svg";